import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './BlogPost.css';
import facebookIcon from '../../../assets/Blog/FB.jpg';
import linkedIcon from '../../../assets/Blog/LinkedIn.jpg';
import mailIcon from '../../../assets/Blog/Mail.jpg';
import copyIcon from '../../../assets/Blog/CopyLink.jpg';
import Card from '../Card/Card';
import CopyLinkImage from '../../../assets/copied-link.svg'
import { fetchAdComponent, fetchBlogPost, getBlogContentWithSubHeadings,fetchRelatedBlogs } from '../../../services/blog/postServices';



const BlogPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blogPost, setBlogPost] = useState(null);
  const [subHeadings, setSubHeadings] = useState([]);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [formattedDate, setFormattedDate] = useState("");
  const [adComponent,setAdComponent]=useState({});
  useEffect(() => {
    const loadBlogPost = async () => {
      try {
        setIsLoading(true);
        const data = await fetchBlogPost(id);
        setBlogPost(data);
        console.log(data.Content)
        setSubHeadings(getBlogContentWithSubHeadings(data.Content));
        const date = new Date(data.Date); // use `data.Date` directly
        const options = { day: '2-digit', month: 'long', year: 'numeric' };
        setFormattedDate(new Intl.DateTimeFormat('en-GB', options).format(date));
      } catch (error) {
        console.error("Error fetching blog post:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadBlogPost();
  }, [id]);

  // Setting meta tags 
  useEffect(() => {
    // Update SEO meta tags
    if (blogPost?.MetaData) {
      
      // Update the page title
      document.title = blogPost.MetaData.metaTitle || "Tripta Innovations Private Limited Blog Post";
      
      // Meta description
      const metaDescription = document.querySelector('meta[name="description"]');
      
      if (metaDescription) {
        metaDescription.setAttribute("content", blogPost.MetaData.metaDescription || "Default Description");
      } else {
        const description = document.createElement("meta");
        description.name = "description";
        description.content = blogPost.MetaData.metaDescription || "Default Description";
        document.head.appendChild(description);
      }

      // Meta image
      const metaimage = document.querySelector('meta[property="og:image"]');
      
      
      if (metaimage) {
        metaimage.setAttribute("content", `${process.env.REACT_APP_STRAPI_API_BASE_URL}${blogPost.MetaData.metaImage?.url}` || "Default Image URL");
      } else {
        const image = document.createElement("meta");
        image.setAttribute("property","og:image");
        const metaImageUrl=`${process.env.REACT_APP_STRAPI_API_BASE_URL}${blogPost.MetaData.metaImage?.url}` || "Default Image URL";
        image.setAttribute("content",metaImageUrl); 
        document.head.appendChild(image);
      }

      // Canonical URL
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      
      if (canonicalLink) {
        canonicalLink.setAttribute("href", blogPost.MetaData.canonicalUrl || window.location.href);
      } else {
        const link = document.createElement("link");
        link.setAttribute("rel","canonical");

        link.setAttribute("href", blogPost.MetaData.canonicalUrl || window.location.href); 
        
        
        document.head.appendChild(link);
      }
      
    }
  }, [blogPost]);

  // Load related posts when `blogPost` and `blogPost.Category` are available
  useEffect(() => {
    if (blogPost?.Category) {
      const loadRelatedPosts = async () => {
        const relatedPosts = await fetchRelatedBlogs(blogPost.documentId);
        const topRelatedPosts = relatedPosts.slice(0, 3); // Only keep the first 3 items
        setRelatedPosts(topRelatedPosts);
      };
      loadRelatedPosts();
    }
    const loadAdcomponent=async()=>{
      const adcomponent=await fetchAdComponent('sidebar-promo');
      
      setAdComponent(adcomponent[0]);
    }
    loadAdcomponent();
    
    
    
    
  }, [blogPost]);
  
  
  
  
  
  const scrollToSection = (headingId) => {
    const element = document.getElementById(headingId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        const notification = document.createElement("div");
        notification.className = "copy-notification";

        notification.innerHTML = `
          <img src="${CopyLinkImage}" alt="Link Icon" class="copy-link-icon" />
          Link Copied!
        `;

        document.body.appendChild(notification);

        setTimeout(() => {
          document.body.removeChild(notification);
        }, 2000); 
      })
      .catch(err => console.error("Failed to copy link: ", err));
  };

  

  if (isLoading) {
    return (
      <div className="loader-container">
        <div className="fading-bars">
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>
    );
  }

  if (!blogPost) {
    return <div>Failed to load blog post.</div>;
  }
  
  return (
    <div className="blog-post-container">
      {/* Centered Title and Image */}
      <div className="blog-post-center">
        <h1 className="blog-post-title">{blogPost.Title}</h1>
        <p className="blog-post-date">{formattedDate}</p>
        <img
          className="blog-post-image"
          src={`${process.env.REACT_APP_STRAPI_API_BASE_URL}${blogPost.Img.url}`}
          alt={blogPost.Title}
        />
      </div>

      {/* Split Layout for Sidebar and Blog Content */}
      <div className="blog-post-split">
        {/* Sidebar with Quick Navigation */}
        <div className="blog-post-sidebar">
          <div className='sidebar-content-container'>
            <div className="quick-navigation">
              <h2>Quick Navigation</h2>
              <ul>
                {subHeadings.map((heading) => (
                  <li key={heading.id}>
                    <a
                      href={`#${heading.id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection(heading.id);
                      }}
                    >
                      {heading.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Social Icons */}
            <div className="social-icons">
              <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noopener noreferrer">
                <img src={facebookIcon} alt="Facebook" />
              </a>
              <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}&title=${encodeURIComponent(blogPost.Title)}`} target="_blank" rel="noopener noreferrer">
                <img src={linkedIcon} alt="LinkedIn" />
              </a>
              <a href={`mailto:?subject=${encodeURIComponent(blogPost.Title)}&body=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noopener noreferrer">
              <img src={mailIcon} alt="Mail" />
              </a>
              <button onClick={handleCopyLink} className="copy-icon" style={{padding:"0", border:"none", background:"transparent" }}>
                <img src={copyIcon} alt="Copy Link" />
              </button>
            </div>

            {/* Promotional Image */}
            <div className="sidebar-promo">
              <img src={`${process.env.REACT_APP_STRAPI_API_BASE_URL}${adComponent.AdImage?.url}`} alt="Promotion" />
            </div>
          </div>
        </div>
        {/* Blog Content */}
        <div className="blog-post-content">
          {blogPost.Content.map((contentItem) => (
            <div key={contentItem.id}>
              {contentItem.Type === 'heading' && contentItem.HTitle ? (
                <h2 id={contentItem.HID}>{contentItem.HTitle}</h2>
              ) : null}
              
              {contentItem.Text &&
                contentItem.Text.map((block, index) => {
                  if (block.type === "paragraph") {
                    return (
                      <p key={index} className="blog-post-paragraph">
                        {block.children.map((textSegment, tIndex) => {
                          if (textSegment.type === "link") {
                            return (
                              <a
                                key={tIndex}
                                href={textSegment.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="blog-content-link"
                              >
                                {textSegment.children.map((linkText, lIndex) => (
                                  <span key={lIndex}>{linkText.text}</span>
                                ))}
                              </a>
                            );
                          }

                          return (
                            <span
                              key={tIndex}
                              style={{
                                fontWeight: textSegment.bold ? "bold" : "normal",
                                fontStyle: textSegment.italic ? "italic" : "normal",
                                textDecoration: textSegment.underline ? "underline" : "none",
                              }}
                            >
                              {textSegment.text}
                            </span>
                          );
                        })}
                      </p>
                    );
                  }

                  if (block.type === "heading") {
                    const HeadingTag = `h${block.level}`; // Dynamically set heading level (h1, h2, h3)
                    return (
                      <HeadingTag key={index} className={`blog-heading h${block.level}`}>
                        {block.children.map((textSegment, tIndex) => {
                          if (textSegment.type === "link") {
                            return (
                              <a
                                key={tIndex}
                                href={textSegment.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="blog-content-link"
                              >
                                {textSegment.children.map((linkText, lIndex) => (
                                  <span key={lIndex}>{linkText.text}</span>
                                ))}
                              </a>
                            );
                          }

                          return (
                            <span
                              key={tIndex}
                              style={{
                                fontWeight: textSegment.bold ? "bold" : "normal",
                                fontStyle: textSegment.italic ? "italic" : "normal",
                                textDecoration: textSegment.underline ? "underline" : "none",
                              }}
                            >
                              {textSegment.text}
                            </span>
                          );
                        })}
                      </HeadingTag>
                    );
                  }
                })}



              {contentItem.Image && (
                <img
                  src={`${process.env.REACT_APP_STRAPI_API_BASE_URL}${contentItem.Image.url}`}
                  alt="Blog Content"
                  className="blog-post-content-image"
                />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Related Posts Section */}
      <div className="related-posts">
        <h2>Related Posts</h2>
        <div className="related-posts-container">
          {relatedPosts?.map((relatedPost) => (
            <Card
              key={relatedPost.documentId}
              id={relatedPost.documentId}
              imageSrc={`${process.env.REACT_APP_STRAPI_API_BASE_URL}${relatedPost.Img.url}`}
              title={relatedPost.Title}
              date={relatedPost.Date}
              category={relatedPost.Category.Name}
              onClick={() => navigate(`/blog/${relatedPost.documentId}`)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPost;
